module.exports = __webpack_public_path__ + "img/character-baby-content.b959bfa0.svg";